module.exports = "/default/fonts/vendor/lightgallery.js/dist/lg.woff?5fd4c338c1a1b1eeeb2c7b0a0967773d";


//////////////////
// WEBPACK FOOTER
// ./node_modules/lightgallery.js/dist/fonts/lg.woff?n1z373
// module id = +k71
// module chunks = 0